
<script>
export default {
  data() {
    return {
      popups: [],
      focusedPopupId: null
    };
  },
  watch: {
    "$route.path"() {
      this.clearPopup();
    }
  },
  methods: {
    openPopup(comp, props = {}, multi = false) {
      if (!multi) this.popups = this.popups.filter(item => item.comp != comp);
      props.uid = this.focusedPopupId = _.uniqueId("popup_");
      this.popups.push({
        comp,
        props
      });
    },
    clearPopup() {
      this.popups = [];
      this.focusedPopupId = null;
    },
    closePopup(uid) {
      this.popups = _.remove(this.popups, item => item.props.uid != uid);
    },
    onMouseDownItem(uid) {
      const index = this.popups.findIndex(item => item.props.uid === uid);
      const item = this.popups[index];
      this.popups.splice(index, 1);
      this.popups.push(item);
    },
    onkeyDown(e) {
      if (this.popups.length && e.keyCode === 27) {
        this.closePopup(_.last(this.popups).props.uid);
      }
    }
  },
  mounted() {
    this.$EventBus.listen(this, "openPopup", this.openPopup);
    this.$EventBus.listen(this, "onErrorPage", this.clearPopup);
    window.addEventListener("keydown", this.onkeyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.onkeyDown);
  },
  render(createElement) {
    const popups = _.map(this.popups, ((item, index) =>
      createElement(item.comp, {
        props: {
          order: index,
          ...item.props
        },
        key: item.props.uid,
        ref: "popupInstances",
        on: {
          close: this.closePopup,
          mousedown: () => this.onMouseDownItem(item.props.uid)
        }
      })
    ));
    return createElement("div", { class: "ly_modal" }, [...popups]);
  }
};
</script>

<style>
.layerPopup {
  overflow: visible;
}
</style>
